export const escapeRegExp = (string: string) =>
  string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const addSuffix = (original: string, suffix: string) => {
  return `${original}${suffix}`;
};
